var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DevizProduse',{ref:"deviz_produse"})
}
var staticRenderFns = []

export { render, staticRenderFns }